module.exports = __webpack_public_path__ + "media/B50.773a9bd8.mp3";